import styled from 'styled-components';

const ICN_CounterWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1em;
  img {
    width: 24px;
    height: 25px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    &:last-of-type {
      margin-left: 0.8em;
    }
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;

const ICN_InputWrapper = styled.div`
  position: relative;
  width: 100%;
  input {
    border: 1px solid
      ${props =>
    props.error ? props.theme.color.error : props.theme.color.border};
    outline: none;
    padding: 0.6em;
    font-size: 1em;
    color: ${props => props.theme.color.text};
    width: 100%;
    border-radius: 4px;
    box-sizing: border-box;
  }
  img {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 21px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
`;

const ICN_Wrapper = styled.div`
  display: flex;
`;

export default {
  ICN_CounterWrapper,
  ICN_InputWrapper,
  ICN_Wrapper
};
